import { render, staticRenderFns } from "./page-9.vue?vue&type=template&id=4aa74350&scoped=true&"
import script from "./page-9.vue?vue&type=script&lang=js&"
export * from "./page-9.vue?vue&type=script&lang=js&"
import style0 from "./page-9.vue?vue&type=style&index=0&id=4aa74350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa74350",
  null
  
)

export default component.exports